import React, { Component } from 'react';

import VideoPlayerConsumer from './VideoPlayerConsumer';

const withVideoPlayer = (WrappedComponent) => {
  const HOC = class extends Component {
    render() {
      const { ...restProps } = this.props;
      return (
        <VideoPlayerConsumer>
          {(context) => <WrappedComponent {...restProps} videoPlayerContext={context} />}
        </VideoPlayerConsumer>
      );
    }
  };

  return HOC;
};

export { withVideoPlayer };
